"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var rxjs_1 = require("rxjs"),
    PINDetectionResponse_1 = require("../model/PINDetectionResponse"),
    PrismaKeyCardBounds_1 = require("../model/PrismaKeyCardBounds"),
    PrismaKeyCodePattern_1 = require("../model/PrismaKeyCodePattern"),
    PrismaKeyDetection = function () {
  function e() {
    this.keyDetectionSubject = new rxjs_1.Subject(), this.Config = {
      keyHoldVerticalSpeed: .75,
      keyNumberHoldTouchPoints: 2,
      minTouchesAllowed: 2
    }, this.paused = !1, this.prismaKeyCodePattern = new PrismaKeyCodePattern_1.PrismaKeyCodePattern(), this.prismaKeyDetectedPin = new Map();
  }

  return e.prototype.setPrismaKeyCardBounds = function (e, t, i, s) {
    this.prismaKeyCardBounds = new PrismaKeyCardBounds_1.PrismaKeyCardBounds(e, t, i, s);
  }, e.prototype.reset = function () {
    this.prismaKeyDetectedPin = new Map();
  }, e.prototype.pause = function () {
    this.paused = !0;
  }, e.prototype.resume = function () {
    this.paused = !1;
  }, e.prototype.checkTouchMove = function (e) {
    if (!(this.paused || e.size < this.Config.minTouchesAllowed)) {
      var o,
          r = 0,
          n = [];

      if (e.forEach(function (e, t) {
        for (var i = 0, s = 1; s < e.length; s++) {
          i += Math.abs(e[s].y - e[s - 1].y);
        }

        r < i && (r = i, n = e, o = t);
      }), o && n.length > this.Config.keyNumberHoldTouchPoints) {
        for (var t = 0, i = n.length - 1; i > n.length - this.Config.keyNumberHoldTouchPoints; i--) {
          t += Math.abs(n[i].y - n[i - 1].y);
        }

        t / this.Config.keyNumberHoldTouchPoints < this.Config.keyHoldVerticalSpeed && this.checkKeyCode(n[n.length - 1].x, n[n.length - 1].y, o);
      }
    }
  }, e.prototype.checkKeyCode = function (e, t, i) {
    if (this.prismaKeyCardBounds) {
      var s = 100 * (e - this.prismaKeyCardBounds.cardX) / this.prismaKeyCardBounds.cardWidth,
          o = 100 * (t - this.prismaKeyCardBounds.cardY) / this.prismaKeyCardBounds.cardHeight;

      if (!(100 < s || 100 < o) && o > this.prismaKeyCodePattern.codeMargin && o < this.prismaKeyCodePattern.codeMargin + this.prismaKeyCodePattern.codeHeight && s > 100 - this.prismaKeyCodePattern.codeWidth) {
        var r = this.prismaKeyDetectedPin.get(i) ? this.prismaKeyDetectedPin.get(i) : [];
        this.decodePIN(o, r), this.prismaKeyDetectedPin.set(i, r);
      }
    }
  }, e.prototype.decodePIN = function (e, t) {
    var i;
    return e > this.prismaKeyCodePattern.codeMargin && e < this.prismaKeyCodePattern.codeLines[0] ? i = "1" : e > this.prismaKeyCodePattern.codeLines[0] && e < this.prismaKeyCodePattern.codeLines[1] ? i = "2" : e > this.prismaKeyCodePattern.codeLines[1] && e < this.prismaKeyCodePattern.codeLines[2] ? i = "3" : e > this.prismaKeyCodePattern.codeLines[2] && e < this.prismaKeyCodePattern.codeLines[3] ? i = "4" : e > this.prismaKeyCodePattern.codeLines[3] && (i = "ok"), i && !t.includes(i) && (t.length && "ok" === t[t.length - 1] && (t = []), t.push(i), this.keyDetectionSubject.next(new PINDetectionResponse_1.PINDetectionResponse(t.join(",")))), t;
  }, e;
}();

exports.PrismaKeyDetection = PrismaKeyDetection;